<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="ListsOverview")
    h1.title Abreiseliste
    .sub-headline Hier können Sie sich eine Abreiseliste generieren lassen.
    
    .calendar-config.margin-top
      v-date-picker(is-expanded :columns="4" is-range v-model="dateRange")

    .button-wrapper.margin-top.right   
      //- b-button(type="is-light" icon-left="cog" @click="createExcel()") Konfiguration
      b-button(type="is-light" icon-left="file-excel" @click="createExcel()" ) Abreise-Excel herunterladen

  .card.margin-top
    .main
      b-table(:data="departuresPlus"
              hoverable)
        b-table-column(label='Nr.' v-slot="props")
          | {{props.index + 1}}
        b-table-column(field='isChange' label='W' v-slot="props")
          b {{props.row.isChange ? 'W' : ''}}
        b-table-column(field='startDate' label='Anreise' sortable v-slot="props" width="120")
          | {{formatDate(props.row.startDate)}}
        b-table-column(field='endDate' label='Abreise' sortable v-slot="props" width="120")
          b {{formatDate(props.row.endDate)}}
        b-table-column(field='rentObject.code' label='Code' sortable v-slot="props")
          | {{props.row.rentObject.code}}
        b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
          div(v-if="props.row.bookingStatus.uuid === 'STATUS_BOOKING_PERSONAL'") {{props.row.rentObject.owner.fullName}}
          div(v-else) {{props.row.customer ? props.row.customer.lastName : '-'}}
        b-table-column(field='parentContractId' label='Miet-V.' sortable v-slot="props")
          a(@click="jumpToBooking(props.row)") {{ props.row.parentContract.id }}
        b-table-column(field='adults' label='Erw.' sortable v-slot="props")
          | {{props.row.adults}}
        b-table-column(field='children' label='Kin.' sortable v-slot="props")
          | {{props.row.children}}
        b-table-column(label='ÜN' sortable v-slot="props" width="120")
          | {{dateDiff(props.row.startDate, props.row.endDate)}}
        b-table-column(label='BW' v-slot="props")
          | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Bettwäsche')}}
        b-table-column(label='HT' v-slot="props")
          | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Handtuchset')}}
        b-table-column(label='KB' v-slot="props")
          | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Kinderreisebett')}}
        b-table-column(label='KH' v-slot="props")
          | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Kinderhochstuhl')}}
        b-table-column(label='Tier' v-slot="props")
          | {{getCountFromBookingExtraCode(props.row.bookingItems, 'Haustier')}}
        b-table-column(label='Abreiseinformation' v-slot="props")
          .edit-text(@click="selectedBooking = props.row; isDepartureInformationModalActive = true")
            b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom')
              b-button(v-if="!props.row.departureInformation" icon-left="plus")
              div(v-else) {{props.row.departureInformation}}
        b-table-column(label='🔑' centered v-slot="props")
          .edit-text(@click="selectedBooking = props.row; isKeycardCountModalActive = true")
            b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom')
              b-button {{props.row.keycardCount}}
        b-table-column(label='Miete gesamt' numeric v-slot="props")
          div(v-if="!props.row.parentContract") -
          div(v-else) {{props.row.parentContract.contracts[props.row.parentContract.contracts.length-1].totalPrice/100 | toCurrency}}
        b-table-column(label='Miete offen' numeric v-slot="props")
          div(v-if="!props.row.parentContract") -
          div(v-else) {{(props.row.parentContract.contracts[props.row.parentContract.contracts.length-1].totalPrice - props.row.payments)/100 | toCurrency}}
        b-table-column(label='Check out' centered v-slot="props")
          b-checkbox(type="is-success" v-model="props.row.checkOut" @input="updateCheckOut($event, props.row.id)")

  b-modal(v-model='isKeycardCountModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6 Schlüsselkarten-Anzahl aktualisieren
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Anzahl",
              rules="required",
              v-slot="{ errors, valid }")
              b-field(
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors")
                b-numberinput(v-model="selectedBooking.keycardCount")
            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="isKeycardCountModalActive = false"
              ) Abbrechen
              b-button(
                type="is-primary",
                @click="handleSubmit(updateBooking)"
              ) Aktualisieren

  b-modal(v-model='isDepartureInformationModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6 An- und Abreise Informationen aktualisieren
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Informationen",
              rules="",
              v-slot="{ errors, valid }")
              b-field(
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors")
                b-input(type="textarea" v-model="selectedBooking.departureInformation" maxlength="1000")
            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="isDepartureInformationModalActive = false"
              ) Abbrechen
              b-button(
                type="is-primary",
                @click="handleSubmit(updateBooking)"
              ) Aktualisieren

</template>

<script>
import { DateTime } from 'luxon';
import * as ExcelJS from 'exceljs';

export default {
  data() {
    return {
      isDepartureInformationModalActive: false,
      isKeycardCountModalActive: false,
      selectedBooking: null,
      departures: [],
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      weekdays: [
        "-",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
        "Sonntag"
      ]
    };
  },
  watch: {
    dateRange: {
      async handler(){
        const loadingComponent = this.$buefy.loading.open();
        this.departures = await this.$store.dispatch("rentObjectBookings/findDepartures", this.dateRange);
        loadingComponent.close();
      },
      deep: true
    }
  },
  computed: {
    departuresPlus() {
      return this.departures.map(a => {
        let payments = 0;
        a.payments.forEach(element => {
          payments += element.total;
        });
        return {
          ...a,
          payments
        }
      });
    },
    uniqueParents() {
      const uniqueParents = {};
      for (let i = 0; i < this.departuresPlus.length; i += 1) {
        const copy = {...this.departuresPlus[i]};
        if (!copy.rentObject.parent) {
          copy.parent = {
            name: 'Andere',
            code: '-'
          }
        }
        if (!uniqueParents[copy.rentObject.parent.name]) {
          uniqueParents[copy.rentObject.parent.name] = [];
          uniqueParents[copy.rentObject.parent.name].push(copy);
        } else {
          uniqueParents[copy.rentObject.parent.name].push(copy);
        }
      }
      return uniqueParents;
    }
  },
  async mounted() {
    this.departures = await this.$store.dispatch("rentObjectBookings/findDepartures", this.dateRange);
  },
  methods: {
    jumpToBooking(booking) {
      this.$router.push({name: 'Booking', params: {id: booking.id}});
    },
    formatDate(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.")
    },
    prettyFormatDate(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("ccc. dd.LL.yy")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("ccc. dd.LL.yy")
    },
    formatDateTime(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.yyyy HH:mm")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy HH:mm")
    },
    toCurrency(value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    dateDiff(start, end) {
      const dtStart = DateTime.fromISO(start);
      const dtEnd = DateTime.fromISO(end);
      return Math.ceil(dtEnd.diff(dtStart, 'day').toObject().days);
    },
    async updateCheckOut(e, id) {
      await this.$store.dispatch("rentObjectBookings/setCheckOut", {id, state: e});
      this.departures = await this.$store.dispatch("rentObjectBookings/findDepartures", this.dateRange);
    },
    async updateBooking() {
      await this.$store.dispatch("rentObjectBookings/updateData", this.selectedBooking);
      this.departures = await this.$store.dispatch("rentObjectBookings/findDepartures", this.dateRange);
      this.isDepartureInformationModalActive = false;
      this.isKeycardCountModalActive = false;
    },
    getCountFromBookingExtraCode(items, code) {
      const item = items.find(i => i.name === code);
      if (item) return item.count;
      return ''
    },
    createExcel() {
      const wb = new ExcelJS.Workbook();

      let rootWs =  wb.addWorksheet('Alle Abreisen', {
        pageSetup:{
          paperSize: 9,
          orientation:'landscape',
          horizontalCentered: true,
          margins: {
            left: 0.2, right: 0.2,
            top: 0.2, bottom: 0.2,
            header: 0.1, footer: 0.1
          }
        }
      });
      this.generateWorksheet(rootWs, this.departuresPlus, 'Alle Abreisen');

      for (const [key, values] of Object.entries(this.uniqueParents)) {
        let ws =  wb.addWorksheet(key, {
          pageSetup:{
            paperSize: 9,
            orientation:'landscape',
            horizontalCentered: true,
            margins: {
              left: 0.2, right: 0.2,
              top: 0.2, bottom: 0.2,
              header: 0.1, footer: 0.1
            }
          }
        });
        this.generateWorksheet(ws, values, key);
      }

      const self = this;
      wb.xlsx.writeBuffer( {
          base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          const start = DateTime.fromJSDate(self.dateRange.start);
          const end = DateTime.fromJSDate(self.dateRange.end);
          a.download = `Abreise_${start.toFormat("dd_LL_yy")}-${end.toFormat("dd_LL_yy")}.xlsx`;
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    generateWorksheet(ws, values, name) {
      const fontOptions = {
         name: 'Arial',
         size: 12
      };
      const columns = [
        { header: 'Nr', key: 'nr', width: 4, style: { font: fontOptions}},
        { header: 'W', key: 'isChange', width: 4, style: { font: fontOptions}},
        { header: 'Abr.', key: 'endDate', width: 8, style: { font: fontOptions}},
        { header: 'Code', key: 'code', style: { font: fontOptions}},
        { header: 'Nachname', key: 'lastName', width: 15, style: { font: fontOptions}},
        { header: 'Miet-V.', key: 'parentContractId', style: { font: fontOptions}},
        { header: 'Er.', key: 'adults', width: 4, style: { font: fontOptions}},
        { header: 'Ki.', key: 'children', width: 4, style: { font: fontOptions}},
        { header: 'ÜN', key: 'nights', width: 4, style: { font: fontOptions}},
        { header: 'BW', key: 'bw', width: 4, style: { font: fontOptions}},
        { header: 'HT', key: 'ht', width: 4, style: { font: fontOptions}},
        { header: 'KB', key: 'kb', width: 4, style: { font: fontOptions}},
        { header: 'KH', key: 'kh', width: 4, style: { font: fontOptions}},
        { header: '🐶', key: 'tier', width: 4, style: { font: fontOptions}},
        { header: 'Infos', key: 'infos', width: 20, style: { font: fontOptions}},
        { header: 'Gesamt', key: 'totalPrice', width: 12, style: { font: fontOptions}},
        { header: 'Offen', key: 'paymentLeft', width: 12, style: { font: fontOptions}},
        { header: '🔑', key: 'keycardCount', width: 3, style: { font: fontOptions}},
        { header: '✅', key: 'checkIn', width: 4, style: { font: fontOptions}},
      ];
      const border = {
        top: {style:'thin', color: {argb:'FFAAAAAA'}},
        left: {style:'thin', color: {argb:'FFAAAAAA'}},
        bottom: {style:'thin', color: {argb:'FFAAAAAA'}},
        right: {style:'thin', color: {argb:'FFAAAAAA'}}
      };
      ws.columns = columns;
      
      const rowOffset = 3;
      ws.duplicateRow(1, 2, true);
      ws.getRow(1).values = [`${name} | ${this.prettyFormatDate(this.dateRange.start)}` + ((this.dateRange.end && this.prettyFormatDate(this.dateRange.start) !== this.prettyFormatDate(this.dateRange.end)) ? ` - ${this.prettyFormatDate(this.dateRange.end)}` : '')];
      ws.mergeCells('A1:R1');

      ws.getRow(2).values = [''];
      ws.getCell('A2').value = `Abreiseliste für: ${this.weekdays[DateTime.fromJSDate(this.dateRange.start).weekday]} bis ${this.weekdays[DateTime.fromJSDate(this.dateRange.end).weekday]}   ${this.formatDate(this.dateRange.start)} - ${this.formatDate(this.dateRange.end)}`;
      ws.getCell('R2').value = `erstellt am: ${this.formatDateTime(new Date())} Uhr`;
      ws.getCell('R2').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFe3f4ff' }}
      ws.pageSetup.printTitlesColumn = 'A:R';
      ws.pageSetup.printTitlesRow = '1:3';

      // Here we add the data
      for (let i = 0; i < values.length; i+= 1) {
        const a = values[i];
        ws.insertRow(i+rowOffset+1, [
          i+1,
          a.isChange ? 'W' : '',
          this.formatDate(a.endDate),
          a.rentObject.code,
          a.customer ? a.customer.lastName : '-',
          a.parentContractId ? '#'+a.parentContractId : '-',
          a.adults,
          a.children,
          this.dateDiff(a.startDate, a.endDate),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Bettwäsche'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Handtuchset'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Kinderreisebett'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Kinderhochstuhl'),
          this.getCountFromBookingExtraCode(a.bookingItems, 'Haustier'),
          a.departureInformation ? a.departureInformation : '',
          a.parentContract ?
          this.toCurrency(a.parentContract.contracts[a.parentContract.contracts.length-1].totalPrice/100) : '',
          a.parentContract && (a.parentContract.contracts[a.parentContract.contracts.length-1].totalPrice - a.payments !== 0) ?
          this.toCurrency((a.parentContract.contracts[a.parentContract.contracts.length-1].totalPrice - a.payments)/100) : '',
          a.keycardCount,
          a.checkIn ? 'x' : ''
        ]);
      }

      // Custom Color Styles
      ws.getColumn('isChange').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('bw').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('ht').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('kb').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('kh').font = { ...fontOptions, bold: true, color: { argb: 'FF104A8E' } };
      ws.getColumn('paymentLeft').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getColumn('infos').font = { ...fontOptions, bold: false, color: { argb: 'FFFF0000' } };
      ws.getRow(1).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' }, size: 24 };
      ws.getRow(2).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
      ws.getRow(3).font = { ...fontOptions, bold: true };

      // Here we align everything and calculate row height
      ws.eachRow(function (row, rowNr) {
        if (rowNr <= 2) return;
        let maxHeight = 0;
        row.eachCell(function (cell) {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = border;
            let maxHeightTemp = cell.value.toString().split('\n').length * 12;
            if (maxHeight < maxHeightTemp) maxHeight = maxHeightTemp;
        });
        if (rowNr >= 4) {
          row.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          row.height = maxHeight < 36 ? 36 : maxHeight;
        }
      });

      // Custom Alignment Styles
      ws.getColumn('lastName').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      ws.getColumn('infos').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      ws.getColumn('totalPrice').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getColumn('paymentLeft').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };

      ws.autoFilter = `A$${rowOffset}:R${rowOffset+values.length}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-text {
  cursor: pointer;
  width: 100%;
  height: 100%;
  white-space: pre-line;
}

.extra-table {
  font-size: 0.8rem;
  td {
    padding: 0;
  }
}
</style>